<template>
  <div>
    <v-container fluid>
      <material-card icon="mdi-clipboard-text" inline title="Followups">
        <v-card-actions>
          <v-btn color="pink" class="white--text" v-on:click="redirectToFollowup()" elevation="1" absolute top right>
            Proceed to Manual Followup
          </v-btn>
          <v-subheader class="font-weight-bold pa-0 darkblue--text">Assigned To --- (Only Enquiry owner can
            edit)</v-subheader>
        </v-card-actions>
        <v-card flat class="px-2">
          <form @submit.prevent="studFollowup">
            <v-row>
              <v-col cols="12" sm="12" md="3" lg="4">
                <span class="body-2 font-weight-medium">Search By</span><span class="error--text ml-1">*</span>
                <v-autocomplete v-model="findEnquiry.searchType" @change="updateSearchValue" class="my-0 py-1" single-line
                  placeholder="" :items="searchType" item-text="text" item-value="value">
                </v-autocomplete>
              </v-col>
              <v-col cols="12" sm="12" md="3" lg="4">
                <span class="body-2 font-weight-medium">Search Value</span><span class="error--text ml-1">*</span>
                <!-- <v-autocomplete placeholder="e.g. 897" :items="findDataArr" :search-input.sync="searchKey" class="my-0 py-1" single-line hide-no-data> </v-autocomplete> -->
                <b-autocomplete v-model="searchKey" placeholder="e.g. 897" :data="findDataArr" @input="studEnquiry()"
                  @keydown="(option) => (option ? getSearchValue(option) : '')"
                  @select="(option) => (option ? getSearchValue(option) : '')">
                </b-autocomplete>
              </v-col>
              <v-col cols="12" sm="12" md="6" lg="4" v-show="total > 0">
                <span class="body-2 font-weight-medium">Action</span>
                <div class="inside">
                  <!-- <v-btn color="success" type="submit" class="mr-4" :class="{ 'mb-2': $vuetify.breakpoint.xs }" readonly><v-icon left>mdi-magnify</v-icon>Search</v-btn> -->
                  <v-btn color="primary" class="white--text" @click="downloadCSVFile()" v-show="total > 0">
                    <v-icon left>mdi-briefcase-download</v-icon> Download CSV
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </form>
        </v-card>
        <v-card-component>
          <v-card-text class="pt-0 pr-1" :class="{
            'd-block py-3': $vuetify.breakpoint.xs,
            'd-flex align-center': $vuetify.breakpoint.smAndUp
          }">
            <v-card-subtitle class="ml-0 pl-0 darkblue--text">
              Assigned To:
              <span class="font-weight-bold">{{
                assignedToUser
                ? assignedToUser.firstName
                  ? `${assignedToUser.firstName}`
                  : '-'
                : '-'
              }}
                {{
                  assignedToUser
                  ? assignedToUser.lastName
                    ? `${assignedToUser.lastName}`
                    : '-'
                  : ''
                }}</span>
              (Only Enquiry owner can edit it.)
              <v-spacer></v-spacer>
            </v-card-subtitle>
            <v-text-field :class="{
                  'mr-0': $vuetify.breakpoint.xs,
                  'mr-5': $vuetify.breakpoint.smAndUp
                }" v-model="search" append-icon="mdi-magnify" class="ml-auto mb-2" label="Search" hide-details
              single-line style="max-width: 350px" />
          </v-card-text>
          <v-divider class="my-0" />
          <v-data-table :footer-props="{
            'items-per-page-options': [5, 10, 20, 40]
          }" :single-expand="true" item-key="srno" :items-per-page="10" :headers="headers" :items="followupData"
            :search="search">
            <template v-slot:item.studentName="{ item }">
              <span>{{ item.studentName ? item.studentName : '' }}</span>
            </template>
            <template v-slot:item.studentClassName="{ item }">
              <span>{{
                item.studentClassName ? item.studentClassName : ''
              }}</span>
            </template>
            <template v-slot:item.sourceID="{ item }">
              <span>{{ getSourceName(item.sourceID) }}</span>
            </template>
            <template v-slot:item.spancoStage="{ item }">
              <span>{{ item.spancoStage }}</span>
            </template>
            <template v-slot:item.actions="{ item }">
              <span>
                <router-link :to="{
                  name: 'followupDetails',
                  params: { enquiryCode: item.enquiryCode }
                }" target="_blank">
                  <v-btn small class="white--text" color="pink">Proceed to Followup</v-btn>
                </router-link>
              </span>
            </template>
            <template v-slot:no-data>
              <v-card-subtitle class="d-flex justify-center">No Data Available</v-card-subtitle>
            </template>
          </v-data-table>
        </v-card-component>
      </material-card>
      <loading-icon :value="isLoading" />
    </v-container>
  </div>
</template>
<script>
// import CardComponent from '@/components/template/CardComponent'
import VCardComponent from '@/components/template/VCardComponent'
import constants from '@/utils/constants'
import moment from 'moment'
import Utils from '@/utils'
import uniq from 'lodash/uniq'
import _ from 'lodash'
import { mapGetters } from 'vuex'
// import ExportUtility from '@/utils/exportUtility'
import MaterialCard from '@/components/template/MaterialCard.vue'

export default {
  name: 'Followup',
  components: {
    // CardComponent,
    MaterialCard,
    VCardComponent
  },
  data () {
    return {
      findEnquiry: {
        academicYearID: '',
        searchType: 'enquirycode',
        searchKey: ''
      },
      total: 0,
      loading: false,
      assignedToUser: '-',
      count: 1,
      isLoading: false,
      franchiseeID: '',
      loadingComponent: null,
      enableFilterModal: false,
      enableEnquiryModal: true,
      dateRange: 'Today',
      searchKey: '',
      academicYears: [],
      academicYearID: '',
      findDataArr: [],
      followupData: [],
      reportData: [],
      spancoDefaultStatus: '',
      spancoDefaultStage: constants.SPANCOSTATUS.DEFAULTSTAGE,
      csvData: [],
      searchType: [
        { text: 'Enquiry Code', value: 'enquirycode' },
        { text: 'Mobile Number', value: 'studentmobile' }
      ],
      headers: [
        { text: 'Sr No', sortable: true, value: 'srno' },
        { text: 'Enquiry Code', sortable: true, value: 'enquiryCode' },
        { text: 'Enquiry Date', sortable: true, value: 'dateOfEnquiry' },
        { text: 'Student Name', sortable: true, value: 'studentName' },
        { text: 'Opting Class', value: 'studentClassName', sortable: true },
        { text: 'Parent Mobile', sortable: true, value: 'fatherMobile' },
        {
          text: 'Source',
          sortable: true,
          value: 'sourceID',
          align: 'center'
        },
        {
          text: 'Spanco status',
          sortable: true,
          value: 'spancoStage',
          align: 'center'
        },
        { text: 'Action', value: 'actions', align: 'center' }
      ],
      search: ''
    }
  },
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee',
      academicYear: 'getAcademicYear',
      updateFollowupAcademicYearID: 'updateFollowupAcademicYearID',
      updateFollowupEnquiryDate: 'updateFollowupEnquiryDate'
    })
  },
  async created () {
    try {
      this.isLoading = true
      this.followupData = []
      this.csvData = []
      await this.getFilterData()
      this.isWrite = Utils.helper.getIsWriteFun(this.$route)

      const { data: questions } = await http.get(
        `${constants.API_URL}/api/enquiry-questions`
      )
      this.stages = questions.filter((obj) => obj.type === 'INTEREST_TYPE')

      this.findEnquiry.searchType = this.$store.state.enquirySearchBy
        ? this.$store.state.enquirySearchBy
        : this.findEnquiry.searchType
      if (this.findEnquiry.searchType === 'enquirycode') {
        this.searchKey = this.$store.state.enquiryCode
          ? this.$store.state.enquiryCode
          : this.searchkey
      } else {
        this.searchKey = this.$store.state.mobileNumber
          ? this.$store.state.mobileNumber
          : this.searchkey
      }

      if (this.$route.query.enquiryDate) {
        this.searchKey = ''
      } else if (this.searchKey) {
        if (this.academicYearID !== '' && this.franchisee.id) {
          await this.studFollowup()
        }
      }
      this.isLoading = false
      this.spancoDefaultStatus = constants.SPANCOSTATUS.DEFAULT
    } catch (e) {
      this.isLoading = false
      const errorMessage =
        (e && e.response && e.response.data.message) || e.message
      console.log('errorMessage', errorMessage)
    }

    if (this.radio2) {
      this.radio = this.radio2
    }
  },
  mounted: async function () {
    if (this.franchisee.id) {
      await this.onFranchiseeChange()
      //   await this.getFilterData()
    }
  },
  watch: {
    franchisee: async function (val) {
      await this.onFranchiseeChange()
    },
    searchKey: async function (val) {
      if (_.isEmpty(val)) {
        this.followupData = []
      } else {
        this.getSearchValue()
      }
    },
    academicYear: async function (val) {
      await this.onFranchiseeChange()
    }
  },

  methods: {
    getSourceName: function (sourceArray) {
      let sourceName = []
      if (sourceArray && sourceArray !== null && typeof sourceArray === 'object') {
        sourceArray.forEach(item => {
          if (item.name) {
            sourceName.push(item.name)
          }
        })
        if (sourceName.length > 0) {
          return sourceName.toString()
        } else {
          return '-'
        }
      }
      return '-'
    },
    getAcademicYears: async function () {
      try {
        const { data } = await http.get(
          `${constants.API_URL}/api/franchiseeAcademicYears`
        )
        this.academicYears = data.rows
        this.flag = false
        const currentAcademicYear = Utils.getCurrentAcademicYear()
        let academicYear = this.academicYears.find((y) => {
          return y.academicYear.trim() === currentAcademicYear.trim()
        })
        this.academicYearID = academicYear ? academicYear.id : ''
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        return this.$dialog.error({
          text: errorMessage,
          title: 'Error'
        })
      } finally {
        this.isLoading = false
      }
    },
    redirectToFollowup: async function () {
      this.$store.commit('updateEnquiryCode', '')
      this.$store.commit('updateMobileNumber', '')
      this.$store.commit('updateSearchBy', '')
      this.$router.push({ name: 'followupManually' })
    },
    reloadPage () {
      window.location.reload()
    },
    getFilterData: async function () {
      let enquiryDate = this.$route.query.enquiryDate
        ? this.$route.query.enquiryDate
        : this.$store.state.followupEnquiryDate
          ? this.$store.state.followupEnquiryDate
          : ''
      let academicYearID = this.$route.query.academicYrID
        ? this.$route.query.academicYrID
        : this.$store.state.followupAcademicYearID
          ? this.$store.state.followupAcademicYearID
          : ''
      let enquiryStageID = this.$route.query.enquiryStageID
        ? this.$route.query.enquiryStageID
        : this.$store.state.enquiryStageID
          ? this.$store.state.enquiryStageID
          : ''
      console.log('Search is being initiated')
      if (enquiryDate) {
        const { data } = await http.post(
          `${constants.API_URL}/api/getfollowupfilter`,
          {
            franchiseeID: this.franchiseeID,
            academicYearID: academicYearID,
            enquiryDate: enquiryDate,
            enquiryStageID: enquiryStageID
          }
        )

        this.followupData = data.rows
        this.followupData.filter((item, index) => {
          item.srno = index + 1
          item.studentName = item.studentFirstName
          if (item.studentMiddleName) {
            item.studentName = item.studentName + ' ' + item.studentMiddleName
          }
          if (item.studentLastName) {
            item.studentName = item.studentName + ' ' + item.studentLastName
          }
          item.type = constants.ENQUIRYSTAGES.YET_TO_CALL
          item.isInterestedForEnquiry =
            item.isInterestedForEnquiry === true
              ? 'Active'
              : 'Not Interested Enquiry'
          item.dateOfEnquiry = moment(item.dateOfEnquiry).format(
            'MMMM Do YYYY, HH:mm a'
          )
          let spancoName = item.spancoStatus
            ? item.spancoStatus
            : this.spancoDefaultStatus
          let spancoStg = item.enquiryStage
            ? item.enquiryStage.name
            : this.spancoDefaultStage
          item.spancoStage = spancoName + '-' + spancoStg
          item.sourceName = item.source ? item.source.name : 'OTHER'
          item.studentClassName = item.studentClass
            ? item.studentClass.name
            : ''
        })
        this.total = this.followupData.length
      }
    },
    getSearchValue: async function (objKey) {
      if (typeof objKey !== 'undefined') {
        this.followupData = []
        this.searchKey = objKey
        this.studFollowup()
      }
    },
    onFranchiseeChange: async function () {
      if (!this.inProgress) {
        this.inProgress = true
        if (this.franchisee) {
          this.franchiseeID = this.franchisee.id
        } else {
          this.franchiseeID = ''
        }

        if (this.academicYear) {
          this.academicYearID = this.academicYear.id
        } else {
          this.academicYearID = ''
        }
        if (this.$route.query.enquiryDate) {
          await this.getFilterData()
        } else if (this.searchKey) {
          await this.studFollowup()
        }
        this.inProgress = false
      }
    },
    onChangeAcademicyearID: async function () {
      if (!this.inProgress) {
        this.inProgress = true
        this.studFollowup()
        this.inProgress = false
      }
    },
    updateSearchValue: function () {
      this.searchKey = ''
    },
    studEnquiry: async function () {
      try {
        if (this.searchKey) {
          //   if (this.franchiseeID) {
          this.findEnquiry.searchKey = this.searchKey
          this.findEnquiry.franchiseeID = this.franchiseeID
          if (
            (this.findEnquiry.searchType === 'enquirycode' &&
              this.findEnquiry.searchKey.length < 3) ||
            (this.findEnquiry.searchType === 'studentmobile' &&
              this.findEnquiry.searchKey.length < 3)
          ) {
            return
          }
          const { data } = await http.post(
            `${constants.API_URL}/api/search-enquiry/`,
            {
              franchiseeID: this.franchiseeID,
              academicYearID: this.academicYear.id,
              searchType: this.findEnquiry.searchType,
              searchKey: this.findEnquiry.searchKey
            }
          )
          if (data) {
            this.findData = data
            this.assignedToUser =
              this.findData.length > 0 ? this.findData[0].user : '-'
            let searchArray = ''
            if (this.findEnquiry.searchType === 'enquirycode') {
              searchArray = uniq(this.findData.map((i) => i.enquiryCode))
            } else {
              searchArray = uniq(this.findData.map((j) => j.fatherMobile))
            }
            this.findDataArr = await this.FilterResultData(searchArray)
          } else {
            const errorMessage = 'No Record Found'
            return this.$dialog.error({
              text: errorMessage,
              title: 'Error'
            })
          }
          //   } else {
          //     const errorMessage = 'Please select franchisee111'
          //     return this.$dialog.error({
          //       text: errorMessage,
          //       title: 'Error'
          //     })
          //   }
        }
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        return this.$dialog.error({
          text: errorMessage,
          title: 'Error'
        })
      }
    },

    FilterResultData: async function (resObj) {
      let result = ''
      result = resObj.filter((option) => {
        let searchval = this.findEnquiry.searchKey
        return option.indexOf(searchval) >= 0
      })
      return result
    },

    studFollowup: async function () {
      if (this.searchKey) {
        this.followupData = []
        this.csvData = []
        try {
          this.findEnquiry.searchKey = this.searchKey
          this.findEnquiry.franchiseeID = this.franchiseeID
          if (
            (this.findEnquiry.searchType === 'enquirycode' &&
              this.findEnquiry.searchKey.length < 3) ||
            (this.findEnquiry.searchType === 'studentmobile' &&
              this.findEnquiry.searchKey.length < 3)
          ) {
            return
          }

          const { data } = await http.post(
            `${constants.API_URL}/api/get-followup/`,
            {
              franchiseeID: this.franchiseeID,
              academicYearID: this.academicYear.id,
              searchType: this.findEnquiry.searchType,
              searchKey: this.findEnquiry.searchKey
            }
          )
          this.followupData = data.rows
          console.log('this.followupdata', this.followupData)
          this.followupData.filter((item, index) => {
            item.srno = index + 1
            item.studentName = item.studentFirstName
            if (item.studentMiddleName) {
              item.studentName = item.studentName + ' ' + item.studentMiddleName
            }
            if (item.studentLastName) {
              item.studentName = item.studentName + ' ' + item.studentLastName
            }
            item.type = constants.ENQUIRYSTAGES.YET_TO_CALL
            item.isInterestedForEnquiry =
              item.isInterestedForEnquiry === true
                ? 'Active'
                : 'Not Interested Enquiry'
            item.dateOfEnquiry = moment(item.dateOfEnquiry).format(
              'MMMM Do YYYY, HH:mm a'
            )
            let spancoName = item.spancoStatus
              ? item.spancoStatus
              : this.spancoDefaultStatus
            let spancoStg = item.enquiryStage
              ? item.enquiryStage.name
              : this.spancoDefaultStage

            item.spancoStage = spancoName + ' - ' + spancoStg
            item.sourceName = item.source ? item.source.name : 'OTHER'
            item.studentClassName = item.studentClass
              ? item.studentClass.name
              : ''
          })
          this.$store.commit('updateSearchBy', this.findEnquiry.searchType)
          if (this.findEnquiry.searchType === 'enquirycode') {
            this.$store.commit('updateEnquiryCode', this.findEnquiry.searchKey)
          }
          if (this.findEnquiry.searchType === 'studentmobile') {
            this.$store.commit('updateMobileNumber', this.findEnquiry.searchKey)
          }

          this.total = this.followupData.length
        } catch (e) {
          const errorMessage =
            (e && e.response && e.response.data.message) || e.message
          return this.$dialog.error({
            text: errorMessage,
            title: 'Error'
          })
        }
      }
    },

    downloadCSVFile: async function () {
      try {
        let response = ''
        let enquiryDate = this.$route.query.enquiryDate
          ? this.$route.query.enquiryDate
          : this.$store.state.followupEnquiryDate
            ? this.$store.state.followupEnquiryDate
            : ''
        let academicYearID = this.$route.query.academicYrID
          ? this.$route.query.academicYrID
          : this.$store.state.followupAcademicYearID
            ? this.$store.state.followupAcademicYearID
            : ''
        let enquiryStageID = this.$route.query.enquiryStageID
          ? this.$route.query.enquiryStageID
          : this.$store.state.enquiryStageID
            ? this.$store.state.enquiryStageID
            : ''

        if (_.isEmpty(this.findEnquiry.searchKey)) {
          response = await http.post(
            `${constants.API_URL}/api/getFollowupfilterCSV`,
            {
              franchiseeID: this.franchiseeID
                ? this.franchiseeID
                : this.franchisee.id,
              academicYearID: academicYearID || this.academicYearID,
              enquiryDate: enquiryDate,
              enquiryStageID: enquiryStageID
            }
          )
        } else {
          //   this.findEnquiry.searchKey = this.searchKey
          //   this.findEnquiry.franchiseeID = this.franchiseeID
          if (
            (this.findEnquiry.searchType === 'enquirycode' &&
              this.findEnquiry.searchKey.length < 3) ||
            (this.findEnquiry.searchType === 'studentmobile' &&
              this.findEnquiry.searchKey.length < 3)
          ) {
            return
          }

          response = await http.post(
            `${constants.API_URL}/api/getFollowupCSV/`,
            {
              franchiseeID: this.franchiseeID,
              academicYearID: this.academicYear.id ? this.academicYearID : '',
              searchType: this.findEnquiry.searchType,
              searchKey: this.findEnquiry.searchKey
            }
          )
        }

        /** * download file */

        if (!_.isEmpty(response)) {
          const getCSVFileUrl = response.data.url
          await this.downloadFile(getCSVFileUrl)
        }
        /** ***** */
      } catch (e) {
        const errorMessage = 'No record to export'
        return this.$dialog.error({
          text: errorMessage,
          title: 'Error'
        })
      }
    },

    downloadFile: async function (urlObj) {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        window.open(urlObj, '_blank')

        this.loadingComponent.close()
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.loadingComponent.close()
        console.log('error in fetching records : ', errorMessage)
        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: errorMessage,
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    makeActive: async function (enquiryID) {
      await this.$dialog.warning({
        text: 'Enquiry is marked as not interested, Do you still want to activate it?',
        title: 'Warning',
        actions: {
          false: {
            text: 'No',
            handle: () => {
              return false
            }
          },
          true: {
            color: 'red',
            text: 'Yes',
            handle: async () => {
              try {
                let response = await http.post(
                  `${constants.API_URL}/api/makeEnquiryActive/`,
                  {
                    enquiryID: enquiryID
                  }
                )
                if (response) {
                  if (!_.isEmpty(this.searchKey)) {
                    await this.studFollowup()
                  } else {
                    await this.getFilterData()
                  }
                  return this.$dialog.confirm({
                    text: 'Enquiry is activated',
                    title: 'Success'
                  })
                } else {
                  const errorMessage = 'Failed to update status !!'
                  return this.$dialog.error({
                    text: errorMessage,
                    title: 'Error'
                  })
                }
              } catch (e) {
                const errorMessage =
                  (e && e.response && e.response.data.message) || e.message
                return this.$dialog.error({
                  text: errorMessage,
                  title: 'Error'
                })
              }
            }
          }
        }
      })
      // await this.$buefy.dialog.confirm({
      //   message: 'Enquiry is marked as not interested, Do you still want to activate it?',
      //   closeOnConfirm: true,
      //   type: 'is-danger',
      //   onConfirm: async () => {
      //     try {
      //       let response = await http.post(`${constants.API_URL}/api/makeEnquiryActive/`, {
      //         enquiryID: enquiryID
      //       })
      //       if (response) {
      //         if (!_.isEmpty(this.searchKey)) {
      //           await this.studFollowup()
      //         } else {
      //           await this.getFilterData()
      //         }
      //         return this.$buefy.dialog.alert({
      //           type: 'is-success',
      //           message: 'Enquiry is activated',
      //           hasIcon: true,
      //           animation: 'zoom-out',
      //           size: 'is-medium',

      //           icon: ' mdi-exclamation',
      //           iconPack: 'mdi',
      //           ariaRole: 'alertdialog',
      //           ariaModal: true
      //         })
      //       } else {
      //         const errorMessage = 'Failed to update status !!'
      //         return this.$buefy.dialog.alert({
      //           type: 'is-danger',
      //           message: errorMessage,
      //           hasIcon: true,
      //           animation: 'zoom-out',
      //           size: 'is-medium',

      //           icon: ' mdi-exclamation',
      //           iconPack: 'mdi',
      //           ariaRole: 'alertdialog',
      //           ariaModal: true
      //         })
      //       }
      //     } catch (e) {
      //       const errorMessage = (e && e.response && e.response.data.message) || e.message
      //       return this.$buefy.dialog.alert({
      //         type: 'is-danger',
      //         message: errorMessage,
      //         hasIcon: true,
      //         animation: 'zoom-out',
      //         size: 'is-medium',

      //         icon: ' mdi-exclamation',
      //         iconPack: 'mdi',
      //         ariaRole: 'alertdialog',
      //         ariaModal: true
      //       })
      //     }
      //   },
      //   onCancel: () => {
      //     return false
      //   }
      // })
    }
  }
}
</script>
